import React from "react";
import Header from "../header/AppHeader";
import ProfileCard from "../profile/ProfileCard";
import background from "../../assets/dashboard-bg.jpg";

const RULES = [
  {
    title: "CA Rules",
    body: "Represent your campus professionally, respond to coordinator messages within 24 hrs, and keep at least one active task in progress each week.",
  },
  {
    title: "Point System",
    body: "Points are awarded per completed task, verified registration, and approved submission. Total points decide your live rank and CA tier (Bronze, Silver, Gold).",
  },
  {
    title: "Social Media Promotion Rules",
    body: "Use only official hashtags, tagged handles, and approved creative assets. No paid boosting or third-party reposting without coordinator sign-off.",
  },
  {
    title: "Registration Rules",
    body: "Every registration must come through your unique referral link or code. Duplicate, fake, or self-referred entries will be rejected and may incur a penalty.",
  },
  {
    title: "Bonus / Penalty Criteria",
    body: "Early or above-target task completion earns bonus points. Missed deadlines, rule violations, or inactive weeks may lead to point deductions.",
  },
];

const Rule = () => {

  return (
    <div
      className="min-h-[100dvh] w-full overflow-x-hidden lg:h-screen lg:w-screen lg:overflow-hidden bg-center bg-cover bg-no-repeat text-[#2B1B17] font-['Montserrat',sans-serif] antialiased flex flex-col"
      style={{ backgroundImage: `url(${background})` }}
    >
      <Header activeTab="Rules" />

      {/* --- HERO SECTION --- */}
      <section className="px-6 md:px-12 pt-6 pb-5 max-w-[1600px] mx-auto w-full flex-shrink-0">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8 relative z-10">

          <div className="text-white flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5 max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-black tracking-tight drop-shadow-sm leading-[1.05] font-['Barlow',sans-serif]">
              CA Rules &amp; Guidelines
            </h1>
            <p className="text-sm md:text-base text-white/90 leading-relaxed font-normal drop-shadow-sm sm:max-w-[40rem]">
              Everything every Campus Ambassador should know about points, promotions, and fair play.
            </p>
          </div>

          {/* PROFILE CARD */}
          <ProfileCard />

        </div>
      </section>

      {/* --- PROGRAM RULES PANEL --- */}
      <main className="max-w-[1600px] mx-auto px-2 md:px-2 w-full relative z-20 overflow-y-auto lg:flex-1 lg:min-h-0 pb-2 flex flex-col">
        <div className="bg-[#F5EFEB]/90 backdrop-blur-md rounded-2xl p-6 md:p-8 shadow-xl border border-white/20 flex flex-col lg:flex-1 lg:min-h-0 lg:overflow-hidden">

          <div className="mb-2 pb-4 border-b border-black/5 flex-shrink-0">
            <h2 className="text-sm font-black tracking-widest text-[#2B1B17]/60 uppercase font-['Barlow',sans-serif]">Program Rules</h2>
            <p className="text-xs text-black/40 font-medium mt-0.5">Spirit 2026 · please read before your first submission</p>
          </div>

          <div className="max-h-[60vh] overflow-y-auto lg:max-h-none lg:flex-1 lg:min-h-0 divide-y divide-black/[0.05]">
            {RULES.map((rule, index) => (
              <div key={rule.title} className="flex gap-5 md:gap-8 py-6 items-start">
                <span className="text-base font-bold text-black/30 w-5 flex-shrink-0 pt-0.5 font-['Barlow',sans-serif]">{index + 1}</span>
                <h3 className="font-bold text-[#2B1B17] w-44 md:w-56 flex-shrink-0 font-['Barlow',sans-serif]">{rule.title}</h3>
                <p className="text-sm text-black/55 leading-relaxed flex-1">{rule.body}</p>
              </div>
            ))}
          </div>

        </div>
      </main>
    </div>
  );
};

export default Rule;